export const FeePayerType = {
  CUSTOMER: 1,
  RECEIVER: 2,
};
